import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { SiblingDiscount } from '../interfaces/sibling-discount';

@Injectable()
export class SiblingDiscountService {
  private _url = '/api/ClubDiscount/';

  constructor(private http: HttpClient) { }

  create(siblingDiscount: SiblingDiscount) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + 'addsiblingdiscount', siblingDiscount, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sibling-discount.service.ts